import styled from 'styled-components';
import palette from '@telus-uds/palette-allium/build/web/palette';

export const FooterMessage = styled.p`
  font-size: 14px;
  color: ${palette.color.redDark};
  font-weight: 500;
`;

export const FooterErrorContainer = styled.div`
  margin-left: 1.2rem;
  max-width: 400px;
  display: inline-block;
`;
